import {RaceFilter, RaceFilterParams} from "./race-filter";
import {DEFAULT_PAGE_SIZE, Pages} from "./pages";
import { RacesByMonth } from "./races-by-month";
import { EventItemType } from "./event-item-type";
import { FindFinished } from "./find-finished";
import { ListSortOrder } from "./list-sort-order";

export class FindRacesRequest {
  constructor(private pages: Pages, private filter: (RaceFilter | RacesByMonth | FindFinished),  private order?: ListSortOrder) {
  }

  static createRecommendRacesFilter(): FindRacesRequest {
    var findRacesRequest: FindRacesRequest = new FindRacesRequest(new Pages(), RaceFilter.createRecommendRacesFilter());
    return findRacesRequest;
  }

  static createRacesFilterRequest(params?: RaceFilterParams): FindRacesRequest {
    var findRacesRequest: FindRacesRequest = new FindRacesRequest(new Pages(), RaceFilter.createRaceFilter(params));
    return findRacesRequest
  }


  static createRacePagedFilter(page: number, params?: RaceFilterParams): FindRacesRequest {
    var findRacesRequest: FindRacesRequest = new FindRacesRequest(new Pages(DEFAULT_PAGE_SIZE, page), RaceFilter.createRaceFilter(params));
    return findRacesRequest
  }

  static createLandingRacesPagedFilterRequest(page: number, type: EventItemType, sortOrder?: ListSortOrder): FindRacesRequest {
    var findRacesRequest: FindRacesRequest = new FindRacesRequest(new Pages(DEFAULT_PAGE_SIZE, page), new FindFinished(type === EventItemType.MY_FINISHED ? false: true), sortOrder ?? ListSortOrder.ASC);
    return findRacesRequest;
  }
}
